// pages/Unauthorized.jsx
export default function Unauthorized() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <h1 className="text-2xl font-bold">403 – Unauthorized</h1>
    </div>
  );
}
